<p-menu #actions [model]="items" [popup]="true" [style]="menuStyle" appendTo="body"> </p-menu>
<button
  [disabled]="disabled"
  type="button"
  [attr.id]="id"
  [attr.data-cy]="dataCy"
  [ngClass]="{
    'atlas-btn': buttonType === 'default',
    'atlas-btn-default': buttonType === 'default',
    'btn-type-ghost': buttonType === 'ghost',
  }"
  [class]="styleClass"
  (click)="actions.toggle($event)"
>
  <span class="label-txt" *ngIf="label">{{ label }}</span>
  <span class="ml-8" [ngClass]="icon"></span>
</button>
